import { useRef } from 'react';
import styles from './style.module.scss';
const SwipeContainer = (props) => {
    const touchStart = useRef({ x: 0, y: 0 });
    const touchEnd = useRef({ x: 0, y: 0 });
    const { minDistance = 30, onSwipeLeft, onSwipeRight } = props;

    const handleTouchStart = (e) => {
        touchStart.current = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
        };
    };
    const handleTouchMove = (e) => {
        touchEnd.current = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
        };
    };

    const handleTouchEnd = () => {
        if (!touchEnd.current.x) return;

        const deltaX = touchEnd.current.x - touchStart.current.x;

        if (Math.abs(deltaX) > minDistance) {
            if (deltaX > 0) {
                onSwipeRight && onSwipeRight();
            } else {
                onSwipeLeft && onSwipeLeft();
            }
        }

        // 重置
        touchStart.current = { x: 0, y: 0 };
        touchEnd.current = { x: 0, y: 0 };
    };
    return (
        <div className={styles.swipeContainer} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
            {props.children}
        </div>
    );
};
export default SwipeContainer;
